/* unplugin-vue-components disabled */import { render } from "./preview.vue?vue&type=template&id=eae70b84&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"

import "./preview.vue?vue&type=style&index=0&id=eae70b84&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eae70b84"]])

export default __exports__